import type { App } from "@upsquad/server";
import type { SkillType } from "@upsquad/shared";
import type { EdenCall } from "@/src/common/lib/eden-base-query";
import { baseApi } from "@/src/common/services/base-api";

type GetSkillsResponse = App["~Routes"]["member"][":communityId"]["skills"]["get"]["response"]["200"];
type CreateSkillResponse = App["~Routes"]["member"][":communityId"]["skills"]["post"]["response"]["200"];
type SetUserSkillsResponse = App["~Routes"]["member"][":communityId"]["me"]["skills"]["put"]["response"]["200"];

interface GetSkillsParams {
	communityId: string;
	type: SkillType;
	search?: string;
}

interface CreateSkillParams {
	communityId: string;
	name: string;
	type: SkillType;
}

interface SetUserSkillsParams {
	communityId: string;
	skillIds: string[];
}

const memberSkillsApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getSkills: builder.query<GetSkillsResponse, GetSkillsParams>({
			query:
				({ communityId, type, search }): EdenCall<GetSkillsResponse> =>
				(client) =>
					client.member({ communityId }).skills.get({ query: { type, search } }),
			providesTags: ["Skills"],
		}),
		createSkill: builder.mutation<CreateSkillResponse, CreateSkillParams>({
			query:
				({ communityId, name, type }) =>
				(client) =>
					client.member({ communityId }).skills.post({ name, type }),
			invalidatesTags: ["Skills"],
		}),
		setUserSkills: builder.mutation<SetUserSkillsResponse, SetUserSkillsParams>({
			query:
				({ communityId, skillIds }) =>
				(client) =>
					client.member({ communityId }).me.skills.put({ skill_ids: skillIds }),
			invalidatesTags: ["MemberDetail"],
		}),
	}),
});

export const { useGetSkillsQuery, useCreateSkillMutation, useSetUserSkillsMutation } = memberSkillsApi;
